document.addEventListener('DOMContentLoaded', function () {
    console.log('quotes-fix activo (blog-main--wrapper)');

    const container = document.querySelector('.blog-main--wrapper .text-link-animated');
    if (!container) return;

    container.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span').forEach(el => {

        let text = el.textContent;
        if (!text) return;

        const trimmed = text.trimStart();

        // Comilla de apertura
        if (trimmed.startsWith('”') || trimmed.startsWith('"')) {
            text = text.replace(/^[\s\u00A0]*[”"]/, '“');
        }

        // Comilla de cierre
        if (trimmed.endsWith('“') || trimmed.endsWith('"')) {
            text = text.replace(/[“"]\s*$/, '”');
        }

        el.textContent = text;
    });
});
